import React from "react";
import { useFormContext } from "react-hook-form";
import { Radio, Flex, Stack, Text } from "@chakra-ui/react";

export interface SmileSharedCustomPlanRadioProps {
  value: string;
  title: string;
  priceText: string;
  priceSubtext: string;
  color: string;
}

const SmileSharedCustomPlanRadio = (props: SmileSharedCustomPlanRadioProps) => {
  const { register } = useFormContext();
  return (
    <Flex
      direction="row"
      justify="space-between"
      bg={props.color}
      px="30px"
      borderRadius="2px"
      h={{ base: "80px", sm: "60px" }}
    >
      <Radio colorScheme="white" value={props.value} name="plan" ref={register}>
        <Flex direction="row" ml="27px">
          <Text
            fontFamily={"Montserrat"}
            fontWeight={"600"}
            fontSize={"14px"}
            lineHeight={"17px"}
            textTransform={"uppercase"}
            color={"white"}
          >
            {props.title ?? "-"}
          </Text>
        </Flex>
      </Radio>
      <Stack w={{ base: "110px", sm: "160px" }} justify="center" textAlign="right">
        <Text
          fontFamily={"Montserrat"}
          fontWeight={"600"}
          fontSize={"14px"}
          lineHeight={"17px"}
          textTransform={"uppercase"}
          color={"white"}
        >
          {props.priceText ?? "-"}
        </Text>
        {props.priceSubtext && (
          <Text
            fontFamily={"Montserrat"}
            fontWeight={"600"}
            fontSize={"9px"}
            lineHeight={"140%"}
            color={"white"}
            mt={"10px"}
          >
            {props.priceSubtext}
          </Text>
        )}
      </Stack>
    </Flex>
  );
};

export default SmileSharedCustomPlanRadio;
